import styled from 'styled-components';
import { TertiaryButtonStyled } from '~/styles';

export const ClearButtonStyled = styled(TertiaryButtonStyled)`
  background-color: ${({ theme }) => theme.colors.orange[100]};

  &:hover {
    background-color: ${({ theme }) => theme.colors.orange[200]};
  }

  &:focus {
    background-color: ${({ theme }) => theme.colors.orange[200]};
  }
`;
